import { CampaignInfo, DeviceInfo, OptionInfo } from '@/types/api/v1//ContractInfoResponse';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

export type ContractInfoStateType = {
  // 契約者情報取得
  contractorInfo: {
    corpName: string;
    lastName: string;
    firstName: string;
    lastNameKana: string;
    firstNameKana: string;
    birthday: string;
    mailAddress: string;
    addressZipCode: string;
    addressPrefecture: string;
    addressCity: string;
    addressTown: string;
    addressOptional: string;
    tel: string;
    telDayTime: string;
    gender: string;
  };
  contractServiceInfo: {
    cnState: string;
    serviceStartDate: string;
    iotServiceNo: string;
    lastName: string;
    firstName: string;
    lastNameKana: string;
    firstNameKana: string;
    tel: string;
    addressZipCode: string;
    addressPrefecture: string;
    addressCity: string;
    addressTown: string;
    addressOptional: string;
    planInfo: {
      planCode: string;
      planName: string;
      manomaBizPlanFlg: string;
    };
    optionInfos: OptionInfo[];
    campaignInfos: CampaignInfo[];
    deviceInfos: DeviceInfo[];
  };
};

export const ContractInfoState = atom<ContractInfoStateType>({
  key: 'ContractInfoState',
  default: {
    // 契約者情報取得
    contractorInfo: {
      corpName: '',
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      birthday: '',
      mailAddress: '',
      addressZipCode: '',
      addressPrefecture: '',
      addressCity: '',
      addressTown: '',
      addressOptional: '',
      tel: '',
      telDayTime: '',
      gender: '',
    },
    contractServiceInfo: {
      cnState: '',
      serviceStartDate: '',
      iotServiceNo: '',
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      tel: '',
      addressZipCode: '',
      addressPrefecture: '',
      addressCity: '',
      addressTown: '',
      addressOptional: '',
      planInfo: {
        planCode: '',
        planName: '',
        manomaBizPlanFlg: '',
      },
      optionInfos: [],
      campaignInfos: [],
      deviceInfos: [],
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default ContractInfoState;
